module.exports = __webpack_public_path__ + "static/media/logo-dev.5f36909b.svg";